import { AttachmentV1Type } from "@rooster/types";
import { DateTime } from "luxon";

export type ParticipantType = {
  name?: string;
  email?: string;
};

export type ParticipantsTypes = ParticipantType[];

export type AvailabilitySlotType = {
  hour: number;
  minute: number;
  available: boolean;
};

export type AvailabilitySlotsType = AvailabilitySlotType[];

export type BookingFormType = {
  firstName?: string;
  lastName?: string;
  email?: string;
  telephone?: string;
  jobRef?: string;
  bookingNote?: string;
  linkedin?: string;
  termsAndConditions?: boolean;
};

export type ScheduledSlotType = {
  hour: number;
  minute: number;
  day: number;
  timeZone: string;
};

export type LegalType = {
  name: string;
  type: string;
  content: { body: string; language: string; _id: string }[];
  description: string;
  _id: string;
  version: number;
  parentId: string;
};

export enum SCHEDULE_STATE {
  SCHEDULING = 1,
  SCHEDULING_SUCCESS = 2,
  SCHEDULING_FAIL = 3,
  MEETING_CANCELLED = 4,
  AVAILABILITY = 5
}

export enum VIEW_STATE {
  AVAILABILITY_VIEW = 0,
  BOOKING_FORM_VIEW = 1,
  MEETING_STATUS_VIEW = 2
}

export type SelectedDateType = DateTime | null;

export type AvailableSlotType = {
  day: number | string;
  times: { hour: number; minute: number; available: boolean }[];
};

export interface IQueryCalendarEventsItem {
  type: "room" | "interviewer";
  value: string;
  provider: "google" | "office365";
  workerId: string;
}

export type AvailabilityQueryType = {
  start: number;
  end: number;
  items: IQueryCalendarEventsItem[] | undefined;
};

export type CalendarAvailabilityPropsType = {
  queryArray: AvailabilityQueryType[];
  availabilityViewInterval: number;
  isUnauthenticated?: boolean;
  client?: string;
  availabilityId?: string;
};

export type ConferenceType = {
  key: string;
  label: string;
  type: string;
  icon: string;
  value: string;
};

type InterviewsCandidateEmailSend = {
  email?: boolean;
  event: boolean;
  sms?: boolean;
};

type RoosterLinkTemplate = {
  attachments: AttachmentV1Type[];
  emailBody: string;
  smsBody?: string;
  htmlMode?: boolean;
  sendOptions: InterviewsCandidateEmailSend;
  subject: string;
  templateID?: string;
};

type SlotGroup = {
  type: string;
  wday?: string;
  date?: string;
  intervals: SlotInterval[];
};

type SlotInterval = {
  from: number;
  to: number;
  isValid: boolean;
  isBusyOverride: boolean;
};

type InterviewerAvailabilityPreferences = {
  timezone: string;
  recurringAvailability: SlotGroup[];
  overriddenAvailability: SlotGroup[];
  isCustomTimeZone?: boolean;
};

type InterviewerAdditionalPreferences = {
  bufferBefore?: number;
  bufferAfter?: number;
  restrictScheduleBefore?: number;
  timeIncrement?: number;
  additionalInformation?: string;
};

type InterviewsHiringManager = {
  countryCode?: string;
  department?: string;
  email: string;
  employeeID: string;
  firstName: string;
  imageURL?: string;
  imageURL40x40?: string;
  key: string;
  lastName: string;
  name: string;
  telephone?: string;
  title?: string;
  type?: string;
  value?: string;
  country?: string;
};

export type RoosterLink = {
  id: string;
  clientId: string;
  userId: string;
  username: string;
  email: string;
  workerId: string;
  hostName: string;
  profileType: string;
  meetingType: string;
  meetingDescription?: string;
  meetingProfileName: string;
  meetingDurationInMins: number;
  meetingAvailabilityWindow: number;
  canCancel: boolean;
  canReschedule: boolean;
  showTentativeAsBusy: boolean;
  interviewers: InterviewsHiringManager[];
  conferenceType: ConferenceType[];
  candidateRequiredFields: string[];
  disabled: boolean;
  candidateEmailTemplate: RoosterLinkTemplate;
  interviewerEmailTemplate: RoosterLinkTemplate;
  availability: InterviewerAvailabilityPreferences;
  additionalPreferences: InterviewerAdditionalPreferences;
  meetingLink: string;
  createdAt: Date;
  updatedAt?: Date;
  organizer?: InterviewsHiringManager;
};
